import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RevOpsLogo } from '@/components/brand/RevOpsLogo';

export function LandingFooter() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const columns = [
    {
      title: t('landing.footer.product'),
      links: [
        { label: t('landing.footer.features'), href: '/features' },
        { label: t('landing.footer.integrations'), href: '/integrations' },
        { label: t('landing.footer.pricing'), href: '/pricing' },
      ],
    },
    {
      title: t('landing.footer.company'),
      links: [
        { label: t('landing.footer.about'), href: '/about' },
        { label: t('landing.footer.blog'), href: '/blog' },
      ],
    },
    {
      title: t('landing.footer.resources'),
      links: [
        { label: t('landing.footer.documentation'), href: '/documentation' },
        { label: t('landing.footer.helpCenter'), href: '/help' },
        { label: t('landing.footer.revopsGuide'), href: '/revops-guide' },
      ],
    },
    {
      title: t('landing.footer.legal'),
      links: [
        { label: t('landing.footer.privacy'), href: '/privacy' },
        { label: t('landing.footer.terms'), href: '/terms' },
      ],
    },
  ];

  return (
    <footer className="border-t border-[#1A1F3C]/10 bg-white py-16">
      <div className="container">
        <div className="grid gap-8 md:grid-cols-5">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <RevOpsLogo size="sm" variant="dark" />
            </Link>
            <p className="text-sm text-[#1A1F3C]/50">
              Revenue Intelligence Platform
            </p>
          </div>

          {columns.map((col, i) => (
            <div key={i}>
              <h4 className="font-semibold text-[#1A1F3C] text-sm mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link, j) => (
                  <li key={j}>
                    <Link
                      to={link.href}
                      className="text-sm text-[#1A1F3C]/50 hover:text-[#4F6CFF] transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-[#1A1F3C]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#1A1F3C]/40">
            © {currentYear} RevOps AI
          </p>
          <p className="text-sm text-[#1A1F3C]/40">
            {t('landing.footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}
